import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import HomePageEight from "./pages/HomePageEight";
import HomePageNine from "./pages/HomePageNine";
import HomePageTen from "./pages/HomePageTen";
import HomePageEleven from "./pages/HomePageEleven";
import GalleryGridPage from "./pages/GalleryGridPage";
import GalleryMasonryPage from "./pages/GalleryMasonryPage";
import GalleryHoverPage from "./pages/GalleryHoverPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import AddBlogPage from "./pages/AddBlogPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import BlogCategory from "./pages/BlogCategory";
import BlogTags from "./pages/BlogTags";
import CreateBlogPage from "./pages/CreateBlog/CreateBlogPage";
import EditBlogPage from "./pages/EditBlog/EditBlogPage";
import SliderManagement from "./pages/SliderManagement/SliderManagement";
import CreateCaseStudyPage from "./pages/CreateCaseStudyPage/CreateCaseStudyPage";
import PublicRoute from "./authRoute/PublicRoute";
import CaseStudyPage from "./pages/CaseStudyPage/CaseStudyPage";
import EditCaseStudyPage from "./pages/EditCaseStudyPage/EditCaseStudyPage";
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import ContactInquiry from "./pages/ContactInquiry";
import ProtectedRoute from "./authRoute/ProtectedRoute";
import PackageEnquiry from "./pages/PackageEnquiry/PackageEnquiry";
import WeProcure from "./pages/WeProcure/WeProcure";
import WeQa from "./pages/WeQa/WeQa";
import MarketingNotifications from "./pages/MarketingNotifications/MarketingNotifications";
import Configuration from "./pages/ShippingCalculator/Configuration";
import ShippingEnquiryPage from "./pages/ShippingEnquiry/ShippingEnquiryPage";
import DiscountPage from "./pages/Discount/DiscountPage";
import SupportComponent from "./pages/Support/SupportComponent";
function App() {

  const localData = JSON.parse(localStorage.getItem("adminData"));

  return (
    <>
      <RouteScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <SignInPage />
            </PublicRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/blog-category"
          element={
            <ProtectedRoute>
              <BlogCategory />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/conatct-inquiry"
          element={
            <ProtectedRoute>
              <ContactInquiry />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/blog-tags"
          element={
            <ProtectedRoute>
              <BlogTags />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/create-blog"
          element={
            <ProtectedRoute>
              <CreateBlogPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/create-case-study"
          element={
            <ProtectedRoute>
              <CreateCaseStudyPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/edit-case-study"
          element={
            <ProtectedRoute>
              <EditCaseStudyPage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/case-study"
          element={
            <ProtectedRoute>
              <CaseStudyPage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/slider-management"
          element={
            <ProtectedRoute>
              <SliderManagement />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/shipment-enquiry"
          element={
            <ProtectedRoute>
              <PackageEnquiry />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/we-procure"
          element={
            <ProtectedRoute>
              <WeProcure />
            </ProtectedRoute>
          }
        />

        {/* Support Module */}

        <Route
          exact
          path="/support"
          element={
            <ProtectedRoute>
              <SupportComponent masterData={localData}  />
            </ProtectedRoute>
          }
        />


        <Route
          exact
          path="/we-qa"
          element={
            <ProtectedRoute>
              <WeQa />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/marketing-notifications"
          element={
            <ProtectedRoute>
              <MarketingNotifications />
            </ProtectedRoute>
          }
        />

        {/* <Route exact path="/create-blog" element={<CreateBlogPage />}/> */}

        {/* <Route exact path='/' element={<HomePageOne />} /> */}
        <Route exact path="/index-2" element={<HomePageTwo />} />
        <Route exact path="/index-3" element={<HomePageThree />} />
        <Route exact path="/index-4" element={<HomePageFour />} />
        <Route exact path="/index-5" element={<HomePageFive />} />
        <Route exact path="/index-6" element={<HomePageSix />} />
        <Route exact path="/index-7" element={<HomePageSeven />} />
        <Route exact path="/index-8" element={<HomePageEight />} />
        <Route exact path="/index-9" element={<HomePageNine />} />
        <Route exact path="/index-10" element={<HomePageTen />} />
        <Route exact path="/index-11" element={<HomePageEleven />} />

        {/* SL */}
        <Route
          exact
          path="/add-user"
          element={
            <ProtectedRoute>
              <AddUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/alert"
          element={
            <ProtectedRoute>
              <AlertPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/assign-role"
          element={
            <ProtectedRoute>
              <AssignRolePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/avatar"
          element={
            <ProtectedRoute>
              <AvatarPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/badges"
          element={
            <ProtectedRoute>
              <BadgesPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/button"
          element={
            <ProtectedRoute>
              <ButtonPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/calendar-main"
          element={
            <ProtectedRoute>
              <CalendarMainPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/calendar"
          element={
            <ProtectedRoute>
              <CalendarMainPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/card"
          element={
            <ProtectedRoute>
              <CardPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/carousel"
          element={
            <ProtectedRoute>
              <CarouselPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/chat-empty"
          element={
            <ProtectedRoute>
              <ChatEmptyPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/chat-message"
          element={
            <ProtectedRoute>
              <ChatMessagePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/chat-profile"
          element={
            <ProtectedRoute>
              <ChatProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/code-generator"
          element={
            <ProtectedRoute>
              <CodeGeneratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/code-generator-new"
          element={
            <ProtectedRoute>
              <CodeGeneratorNewPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/colors"
          element={
            <ProtectedRoute>
              <ColorsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/column-chart"
          element={
            <ProtectedRoute>
              <ColumnChartPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/company"
          element={
            <ProtectedRoute>
              <CompanyPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/currencies"
          element={
            <ProtectedRoute>
              <CurrenciesPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/dropdown"
          element={
            <ProtectedRoute>
              <DropdownPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/email"
          element={
            <ProtectedRoute>
              <EmailPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/faq"
          element={
            <ProtectedRoute>
              <FaqPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/forgot-password"
          element={
            <ProtectedRoute>
              <ForgotPasswordPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/form-layout"
          element={
            <ProtectedRoute>
              <FormLayoutPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/form-validation"
          element={
            <ProtectedRoute>
              <FormValidationPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/form"
          element={
            <ProtectedRoute>
              <FormPage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/gallery"
          element={
            <ProtectedRoute>
              <GalleryPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/gallery-grid"
          element={
            <ProtectedRoute>
              <GalleryGridPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/gallery-masonry"
          element={
            <ProtectedRoute>
              <GalleryMasonryPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/gallery-hover"
          element={
            <ProtectedRoute>
              <GalleryHoverPage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/blog"
          element={
            <ProtectedRoute>
              <BlogPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/blog-details"
          element={
            <ProtectedRoute>
              <BlogDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/configuration"
          element={
            <ProtectedRoute>
              <Configuration />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/discount"
          element={
            <ProtectedRoute>
              <DiscountPage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/shipping-calculator-enquiry"
          element={
            <ProtectedRoute>
              <ShippingEnquiryPage />
            </ProtectedRoute>
          }
        />
        {/* <Route  path='/blog/:slug' element={<BlogDetailsPage />} /> */}

        <Route
          exact
          path="/add-blog"
          element={
            <ProtectedRoute>
              <AddBlogPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/edit-blog"
          element={
            <ProtectedRoute>
              <EditBlogPage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/testimonials"
          element={
            <ProtectedRoute>
              <TestimonialsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/coming-soon"
          element={
            <ProtectedRoute>
              <ComingSoonPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/access-denied"
          element={
            <ProtectedRoute>
              <AccessDeniedPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/maintenance"
          element={
            <ProtectedRoute>
              <MaintenancePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/blank-page"
          element={
            <ProtectedRoute>
              <BlankPagePage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/image-generator"
          element={
            <ProtectedRoute>
              <ImageGeneratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/image-upload"
          element={
            <ProtectedRoute>
              <ImageUploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/invoice-add"
          element={
            <ProtectedRoute>
              <InvoiceAddPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/invoice-edit"
          element={
            <ProtectedRoute>
              <InvoiceEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/invoice-list"
          element={
            <ProtectedRoute>
              <InvoiceListPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/invoice-preview"
          element={
            <ProtectedRoute>
              <InvoicePreviewPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/kanban"
          element={
            <ProtectedRoute>
              <KanbanPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/language"
          element={
            <ProtectedRoute>
              <LanguagePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/line-chart"
          element={
            <ProtectedRoute>
              <LineChartPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/list"
          element={
            <ProtectedRoute>
              <ListPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/marketplace-details"
          element={
            <ProtectedRoute>
              <MarketplaceDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/marketplace"
          element={
            <ProtectedRoute>
              <MarketplacePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/notification-alert"
          element={
            <ProtectedRoute>
              <NotificationAlertPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/notification"
          element={
            <ProtectedRoute>
              <NotificationPage />
            </ProtectedRoute>
          }
        />
        <Route exact path="/pagination" element={<PaginationPage />} />
        <Route exact path="/payment-gateway" element={<PaymentGatewayPage />} />
        <Route exact path="/pie-chart" element={<PieChartPage />} />
        <Route exact path="/portfolio" element={<PortfolioPage />} />
        <Route exact path="/pricing" element={<PricingPage />} />
        <Route exact path="/progress" element={<ProgressPage />} />
        <Route exact path="/radio" element={<RadioPage />} />
        <Route exact path="/role-access" element={<RoleAccessPage />} />
        {/* <Route exact path='/sign-in' element={<SignInPage />} /> */}
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="/star-rating" element={<StarRatingPage />} />
        <Route exact path="/starred" element={<StarredPage />} />
        <Route exact path="/switch" element={<SwitchPage />} />
        <Route exact path="/table-basic" element={<TableBasicPage />} />
        <Route exact path="/table-data" element={<TableDataPage />} />
        <Route exact path="/tabs" element={<TabsPage />} />
        <Route exact path="/tags" element={<TagsPage />} />
        <Route exact path="/terms-condition" element={<TermsConditionPage />} />
        <Route
          exact
          path="/text-generator-new"
          element={<TextGeneratorNewPage />}
        />
        <Route exact path="/text-generator" element={<TextGeneratorPage />} />
        <Route exact path="/theme" element={<ThemePage />} />
        <Route exact path="/tooltip" element={<TooltipPage />} />
        <Route exact path="/typography" element={<TypographyPage />} />
        <Route exact path="/users-grid" element={<UsersGridPage />} />
        <Route exact path="/users-list" element={<UsersListPage />} />
        <Route exact path="/view-details" element={<ViewDetailsPage />} />
        <Route exact path="/video-generator" element={<VideoGeneratorPage />} />
        <Route exact path="/videos" element={<VideosPage />} />
        <Route exact path="/view-profile" element={<ViewProfilePage />} />
        <Route exact path="/voice-generator" element={<VoiceGeneratorPage />} />
        <Route exact path="/wallet" element={<WalletPage />} />
        <Route exact path="/widgets" element={<WidgetsPage />} />
        <Route exact path="/wizard" element={<WizardPage />} />

        <Route exact path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
